import styled from 'styled-components'
import { flexbox, FlexboxProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  FlexboxProps & GapProps
>`
  display: flex;

  ${gap}
  ${flexbox}
`

export const StyledLink = styled.a`
  display: flex;
  gap: ${themeGet('space.3')}px;
  color: ${themeGet('colors.text.inverse')};
  text-decoration: none;
`
